import { useIsOwnerTenant } from '@/shared/auth/store'

import { GetStarted, GetStartedSkeleton } from './get-started'
import { QuickStart, QuickStartSkeleton } from './quick-start'

export const TaskList = () => {
	const isOwnerTenant = useIsOwnerTenant()

	if (!isOwnerTenant) return null

	return (
		<div>
			<QuickStart />

			<GetStarted />
		</div>
	)
}

export const TaskListSkeleton = () => {
	return (
		<div>
			<QuickStartSkeleton />
			<GetStartedSkeleton />
		</div>
	)
}
